import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle } from 'lucide-react';
import { Button } from './Button';
import { CHECKOUT_URL, trackCheckout } from '../utils/checkout';
export function Hero() {
  return <section className="relative pt-6 sm:pt-10 pb-12 px-4 overflow-hidden bg-white" data-id="element-152" data-mp="9luzmm7107tq">
      <div className="max-w-5xl mx-auto flex flex-col items-center text-center" data-id="element-153" data-mp="4mi47d239sfj">
        <motion.div initial={{
        opacity: 0,
        y: 16
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} className="w-full" data-id="element-154" data-mp="1297ba1bnev89">
          <div className="inline-block px-3 py-1 rounded-full border border-gold/60 bg-gold/10 text-navy font-medium text-[10px] sm:text-sm tracking-wide whitespace-nowrap mb-4 sm:mb-6" data-id="element-155" data-mp="sarsqmqosuad">
            🏃 Track &amp; Field Coach Ready
          </div>

          <h1 className="text-2xl sm:text-4xl md:text-5xl lg:text-6xl font-serif font-bold leading-tight mb-4 sm:mb-6 text-navy" data-id="element-156" data-mp="3d2tln1u126au">
            Solve Your Track &amp; Field Training Plan in Just{' '}
            <span className="text-gold-solid" data-id="element-157" data-mp="3j9alrqbghebh">5 MINUTES</span>
          </h1>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.96
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.3,
        delay: 0.1,
        ease: [0.23, 1, 0.32, 1]
      }} className="relative w-full max-w-[320px] sm:max-w-lg md:max-w-2xl mb-4 sm:mb-6" data-id="element-158" data-mp="3o6u5v6uu4lbc">
          <img src="https://cdn.magicpatterns.com/uploads/17RDhXDxVSNh5rc3t7dysu/Diseno_sin_titulo_(63).png" alt="Track & Field Coach Ready — complete 7-volume coaching system with 150 ready-to-run sessions and 5 professional bonus guides" className="relative z-10 w-full h-auto drop-shadow-2xl" data-id="element-159" data-mp="30gq4z7916zo1" />
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 16
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.3,
        delay: 0.2,
        ease: [0.23, 1, 0.32, 1]
      }} className="w-full" data-id="element-160" data-mp="2hix224yeqpqn">
          <p className="text-sm sm:text-lg md:text-xl text-slate leading-snug max-w-2xl mx-auto mb-5 sm:mb-7" data-id="element-161" data-mp="s2tbjfzvhzn3">
            Track &amp; Field Coach Ready — a complete 7-volume coaching system with 150
            ready-to-run sessions covering sprints, hurdles, relays, endurance, race walking,
            jumps, throws, athlete monitoring, competition planning and program design — all
            organized and ready to use.
          </p>

          <div className="flex justify-center mb-5 sm:mb-7" data-id="element-162" data-mp="161t24t6y4olw">
            <Button href={CHECKOUT_URL} onLinkClick={trackCheckout} className="text-sm sm:text-lg md:text-xl py-3 sm:py-5 px-5 sm:px-10 whitespace-nowrap" data-id="element-163" data-mp="162c8dcn8hok3">
              🟡 GET THE COMPLETE COACHING SYSTEM NOW
            </Button>
          </div>

          <div className="flex flex-wrap justify-center gap-x-4 gap-y-2 text-xs sm:text-sm text-azure-dark" data-id="element-164" data-mp="3lui70k7oini7">
            <div className="flex items-center gap-1.5" data-id="element-165" data-mp="3hq27r1skmeby">
              <CheckCircle size={14} className="text-success" data-id="element-166" data-mp="1xa43telg8kjm" />
              <span data-id="element-167" data-mp="21awco6qesnfd">7 Complete Professional Volumes</span>
            </div>
            <div className="flex items-center gap-1.5" data-id="element-168" data-mp="21b66k5ekreqc">
              <CheckCircle size={14} className="text-success" data-id="element-169" data-mp="269r2hsmsnc8z" />
              <span data-id="element-170" data-mp="2b0pmp3awkuhi">5 High-Value Bonus Guides</span>
            </div>
            <div className="flex items-center gap-1.5" data-id="element-171" data-mp="2b20qv489g495">
              <CheckCircle size={14} className="text-success" data-id="element-172" data-mp="2g0c3tntuquvl" />
              <span data-id="element-173" data-mp="2g257cu964yzd">Immediate Access</span>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}